<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      highlight-current-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
      @current-change="onCurrentChange"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || '查看'"
            placement="top"
          >
            <i
              class="el-icon-view tool-btn"
              @click="$emit('openEditFormDialog', row.orgCode)"
            ></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">{{ $l('INDEX.tips_no_data') || '暂无数据！' }}</p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    tablePage: {
      default: null,
      type: Object,
    },
    loading: {
      default: false,
    },
  },
  components: {},
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
      },
      tableColumns: [
        {
          field: 'seq',
          width: 50,
          align: 'center',
          fixed: 'left',
          type: 'seq',
        },
        // {
        //   field: 'col-opt',
        //   title: this.$l('INDEX.table_label_operation') || '操作',
        //   align: 'center',
        //   fixed: 'left',
        //   width: 90,
        //   slots: {
        //     default: 'opt',
        //   },
        // },
        // {
        //   title: this.$l('table_label_org_no') || '机构编号',
        //   field: 'orgNo',
        //   width: 180,
        //   align: 'center',
        //   fixed: 'left',
        //   showHeaderOverflow: 'title',
        //   showOverflow: 'ellipsis',
        //   sortable: true,
        //   sortType: 'string',
        // },
        {
          title: this.$l('table_label_org_name') || '机构名称',
          field: 'orgName',
          minWidth: 250,
          align: 'left',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          sortable: true,
          sortType: 'string',
        },
      ],
    }
  },
  methods: {
    onCurrentChange({ row }) {
      this.$emit('orgRowChange', row)
    },
  },
}
</script>
